import styles from '../checkout/etskills.module.scss'
import { RiDeleteBin6Line } from "react-icons/ri";
import NextImg from "next/image";
import { IoIosArrowRoundForward,IoIosArrowRoundBack } from "react-icons/io"
import { useRouter } from 'next/router';

import axios from 'axios';
import endpoints from '../../../utility/endpoints';
import { toast } from "react-toastify";
import { useState, useEffect } from 'react';
import Loader from '../../elements/Loader';
const ETskills = ({onNext}) => {
    const route = useRouter()
    const storedCart = JSON.parse(localStorage.getItem('cartpopdata'));
    let auth = JSON.parse(localStorage.getItem("auth")).data;
    const [allData,setAllData]=useState([]);
    const [isLoadings, setIsLoadings] = useState(true);
    const [deleted,setDeleted]=useState(false);
    const [skillItem,setSkillItem]=useState();
    const [skillPrice,setSkillPrice]=useState();
    const botImages = {
        SS00005: '/Currency Converter.png',
        SS00006: '/Schedule Meeting with Gen AI.png',
        SS00007: '/Send Emails.png',
        SS00009: '/Profile Specific Business News.png',
        SS00010: '/Profile Specific Organization Chart.png',
        SS00011: '/Profile Specific Roles & Responsibilities.png',
        SS00013: '/FAQ - SOPs, Knowledge Articles etc..png',
        SS00019: '/Dictionary.png',
        SS00023: '/Weather Report- Broadcastper request.png',
        SS00024: '/PPT Creation with Grunt.png',
        SS00025: '/World Clock.png',
        SS00027: '/Document Utilities.png',
        SS00028: '/Summarization.png',
        SS00034: '/ChatGPT translation.png',
        SS00035: '/Proof read documents.png',
        SS00042: '/Knowledge Management.png',
        SS00043: '/Ask ChatGPT.png',
        SS00044: '/Treasury.png',
        6099: '/BlueCollar Compensation Change.png',
        6100: '/BlueCollar Cost Centre Change.png',
        6101: '/BlueCollar LM Change.png',
        6357: '/Remove Unutilized BMI WBS.png',
        6405: '/Employee Advance-Knockoff.png',
        6554: '/TA Forms in Cognos.png',

        6235: '/Channel review.png',
        6170: '/POT_KPI DASHBOARD.png',
        6257: '/Consolidated financials.png',
        6293: '/Provision Proposal Notes.png',
        6312: '/B&W PBI KPI Dashboard.png',
        6500: '/TA Forms In Cognos Automation-OCR.png',

        5887: '/Balance Sheet P&L.png',
        6031: '/PNCC CNCC Non-Freight.png',
        6141: '/P2P_Progress barcode report.png',
        6417: '/SC - CS - DSLR ECOM.png',
        6422: '/DSLR Retail Process.png',

        6018: '/VAR Report.png',
        6476: '/CCR BaseFile Updation.png',
        6019: '/POR Tracker.png',
        5909: '/Related Party Transaction.png',
        5991: '/NSA Tracker.png',
        6032: '/Promo Slab Evaluation.png',
        6050: '/PLBS Phase 2.png',
        6104: '/Segment PL.png',
        6142: '/SEGMENT BALANCE SHEET.png',
        6259: '/UL FR Master Data Report.png',
        6306: '/SC - CS - Appointment Plan SAP.png',
        6308: '/SAP Master Extract.png',
        6340: '/Returns data.png',
        6350: '/Order Drop.png',
        6353: '/Allocation Report.png',
        6366: '/CS HANA Reports.png',
        6381: '/Bills Discounting Vendor Names.png',
        6401: '/PO Prioritization Retail.png',
        6404: '/ULBPSUPCUSF121POPrioritizationEcom.png',
        6409: '/PO Prioritization CSD.png',
        6412: '/FSA_Addition.png',
        6433: '/SC CS Retail MORE MRP Updation.png',
        6445: '/Duplicate Lines Check.png',
        6448: '/SC-CS-ECOMM Availability Master.png',
        6449: '/MOP Preparation.png',
        6464: '/Credit Blocks and Stamp Removal.png',
        6474: '/SC-CS-ECOMM Assortment Tracker.png',
        6485: '/BMI Scheduling.png',
        6486: '/CAPEX Reporting and MIS.png',
        6501: '/WBS Utilization Report.png',
        6298: '/Innoflex PBI Refresh.png'
    };


    //const totalCost = storedCart.reduce((acc, item) => acc + item.price, 0);

    const deleteCartSkill = async (item) => {
        const { data } = await axios({
          url: `${endpoints.baseUrl}/twin/deleteSelectedSkill?skillID=${item.skillID}`,
          method: "GET",
          headers: {
            Authorization: `${auth.accessToken}|${auth.email}`,
          },
        });
        //console.log(data);
        if (data.code === 200) {
          console.log("data deleted from cart");
          setDeleted(!deleted);
        } else {
          console.log("No data found");
        }
        toast.warn(`${item?.skillName} is removed`, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
       
    };
    const fetchData = async () => {
        let auth = JSON.parse(localStorage.getItem("auth")).data;
        try {
          const resp = await axios({
            url:`${endpoints.baseUrl}/twin/getselectedSkills`,
            method: "GET",
            headers: {
              Authorization: `${auth.accessToken}|${auth.email}`,
            },
           
          });
         localStorage.setItem('orderID',JSON.stringify(resp.data.response.orderID))
          console.log(resp);

               if (resp.data.code === 200) {
        if(resp.data.response){
          setAllData(resp.data.response.selectedSkills);
          setSkillItem(resp.data.response.totalItemsInMiniCart);
          setSkillPrice(resp.data.response.totalPriceOfMiniCart);
        }
        else{
          setAllData([]);
          setSkillItem(0)
        }
      
    
      console.log(resp);
      }
      else{
        setSkillItem(0)
      }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      useEffect(() => {
        setIsLoadings(true)
         const fetchDataTimeout = setTimeout(() => {
             setIsLoadings(false)
            fetchData();
          }, 1500); // 3000 milliseconds = 3 seconds
        
          return () => {
            // Clear the timeouts if the component unmounts or if the dependency changes
            clearTimeout(fetchDataTimeout);
          };
        }, [deleted]);
    return (
        <div className={styles.maincontainer}>
            <p className={styles.skillsheading}>Your Employee Twin Skills</p>
            <div className={styles.customTable}>
                <table className={`table table-striped `} style={{width:"100%"}}>
                    <thead className={styles.skillsheaddiv}>
                        <tr className={styles.tr}>
                            <th className={styles.skillthead}>Skill Name</th>
                            <th className={styles.skillthead}>Cost</th>
                            <th className={styles.skillthead}></th>
                        </tr>
                    </thead>
                    {isLoadings ? (
            <div className="text-center my-6">
              <Loader />
            </div>
          ) : (
                    <tbody className={styles.skilltbody}>
                        {allData.map((item, index) => (
                            <tr key={index} className={index % 2 === 0 ? styles.evenRow : styles.oddRow}>
                                <td className={styles.skillstd}>
                                    <div className={styles.skillidcontainer}>
                                        <div>
                                            {botImages[item.skillID] ? (
                                                <NextImg src={`https://bnlwestgunileveraf01092.blob.core.windows.net/botstorevideo/employeetwin/skills/all${botImages[item.skillID]}`} alt="skill" height={60} width={60} />
                                            ) : (
                                                <NextImg src={"/imagess/skill.png"} alt="skill" height={70} width={70} />
                                            )}
                                        </div>
                                        <div className={styles.skillidname}>
                                            <div className={styles.skillbotid}>{item.skillID}</div>
                                            <div className={styles.skillbotname}>{item.skillName}</div>
                                        </div>
                                    </div>
                                </td>
                                <td className={`${styles.skillstd} ${styles.skillbotprice}`}>€{item.price}</td>
                                <td className={styles.skillstd}>
                                    <div className={styles.skillsdltbtndiv} onClick={() => {deleteCartSkill(item)}}>
                                        <RiDeleteBin6Line />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
      )}
                </table>
            </div>
            <div className={styles.totalskillcontainer}>
               {/* <div className={styles.skilldiscount}>
                    <div className={styles.skillinner}>
                        <div className={styles.softbg}>
                            <p className={styles.softfree}>
                                Free
                            </p>
                        </div>
                        <div>
                            <p className={styles.softskill}>Soft skills Package (10 Skills)</p>
                            <p className={styles.showskill}><u>Show Skills</u></p>
                        </div>
                        <div className={styles.skillsfreecost}>
                            €0
                            <span className={styles.skillsfreecostspan}><del>€100</del></span>
                        </div>
                    </div>
                </div>*/}
                <div className={styles.totalskillcontent}>
                    <div className={styles.skillhirebtn}>
                      <button className="d-flex" onClick={()=>route.push('checkout/all?origin=home')}>
                        <IoIosArrowRoundBack className={styles.skillarrowbtn} />Back
                      </button>
                    </div>
                    <div>
                        <p className={styles.ETskillstotal}>Total Skills</p>
                        <p className={styles.ETskillstotalnumber}>{skillItem} skills</p>
                    </div>
                    <div className={styles.costcontainer}>
                        <p className={styles.ETskillstotal}>Total Cost</p>
                        <p className={styles.ETskillstotalnumber}>€{skillPrice}</p>
                    </div>
                    {/* <div className={styles.skillhirebtn}>
                        <button onClick={() => route.push('/ETprofile')}>
                            Proceed to hire
                        </button>
                        <IoIosArrowRoundForward className={styles.skillarrowbtn} />
                    </div> */}
                    <div className={styles.skillhirebtn}>
                        <button onClick={() => onNext({ skilldata: allData})}>
                            Proceed to hire
                        </button>
                        <IoIosArrowRoundForward className={styles.skillarrowbtn} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ETskills;
